import { createReducer, on } from '@ngrx/store';
import { setStateAction } from '../actions/admin-mda-revenue-head-detail.actions';
import { Action } from '../../models';
import dayjs from 'dayjs';

export interface MdaRevenueHeadDetailReducerInitialState {
  maxDate: string;
  minDate: string;
  esId: string;
  month: number;
  year: number;
}

export const initialState: MdaRevenueHeadDetailReducerInitialState = {
  maxDate: '',
  minDate: '',
  esId: '',
  month: dayjs().month() + 1,
  year: dayjs().year(),
};

const reducer = createReducer(
  initialState,
  on(setStateAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  }),
);

export function mdaRevenueHeadDetailReducerReducer(
  state: MdaRevenueHeadDetailReducerInitialState,
  action: Action,
) {
  return reducer(state, action);
}
